export default {
  namespaced: true,
  state: {
    type: null,
    query: {
      phone: null,
      source: null,
      coupon_code: null,
      qrcode: null,
      store_code: null,
      brand: null,
      event_name: null,
      need_bind_store: false
    },
    redeemData: {
      coupon_id: null,
      item_id: null,
      iten_name: null,
      verify_code: null,
      store_code: null,
      coupon_type: null,
      coupon_code: null
    },
    isMember: false,
    isBindStore: false,
    thanksMessage: "",
  },
  getters: {
    queryData({query}) {
      return query;
    },
    couponType({type}) {
      return type;
    },
    redeemData({redeemData}) {
      return redeemData;
    },
    isMember({isMember}) {
      return isMember;
    },
    isBindStore({isBindStore}) {
      return isBindStore;
    },
    thanksMessage({thanksMessage}) {
      return thanksMessage;
    }
  },
  mutations: {
    SET_THANKS_MESSAGE(state, message) {
      state.thanksMessage = message;
    },
    SET_QUERY(state, query) {
      state.query = query;
    },
    SET_COUPON_TYPE(state, type) {
      state.type = type;
    },
    RESET_DATA(state) {
      state.query = {
        phone: null,
        source: null,
        coupon_code: null,
        qrcode: null,
        store_code: null,
        brand: null,
        event_name: null,
        need_bind_store: false
      }
      state.type = null
    },
    SET_REDEEM_DATA(state, item) {
      state.redeemData = item;
    },
    SET_IS_MEMBER(state, isMember) {
      state.isMember = isMember;
    },
    SET_IS_BIND_STORE(state, isBindStore) {
      state.isBindStore = isBindStore
    },
  },
  actions: {
    setThanksMessage(context, message) {
      context.commit('SET_THANKS_MESSAGE', message);
    },
    updateQuery(context, params) {
      let query = context.state.query
      query = Object.assign(query, params)
      context.commit('SET_QUERY', query)
    },
    setQuery(context, query) {
      context.commit('SET_QUERY', {
          phone: query.phone,
          source: query.source,
          coupon_code: query.coupon_code,
          qrcode: query.qrcode,
          store_code: query.store_code,
          brand: query.brand,
          event_name: query.event_name,
          need_bind_store: query.need_bind_store
      })
      context.commit('SET_COUPON_TYPE', query.type)
    },
    resetQuery(context) {
      context.commit('RESET_DATA')
    },
    setRedeemData(context, item) {
      console.log("[AND Store] setRedeemData called with:", item);
      let redeemData = { ...context.state.redeemData }
      redeemData.coupon_id = item.coupon_id
      redeemData.item_id = item.item_id
      redeemData.item_name = item.item_name
      console.log("[AND Store] Updated redeemData:", redeemData);
      context.commit('SET_REDEEM_DATA', redeemData)
    },
    setCouponIdData(context, code) {
      let redeemData = context.state.redeemData
      redeemData.coupon_id = code
      context.commit('SET_REDEEM_DATA', redeemData)
    },
    setCouponCodeData(context, code) {
      let redeemData = context.state.redeemData
      redeemData.coupon_code = code
      context.commit('SET_REDEEM_DATA', redeemData)
    },
    setVerifyCode(context, code) {
      console.log("[AND Store] setVerifyCode called with:", code);
      let redeemData = { ...context.state.redeemData }
      redeemData.verify_code = code
      console.log("[AND Store] Updated redeemData:", redeemData);
      context.commit('SET_REDEEM_DATA', redeemData)
    },
    setStoreCode(context, code) {
      console.log("[AND Store] setStoreCode called with:", code);
      let redeemData = { ...context.state.redeemData }
      redeemData.store_code = code
      console.log("[AND Store] Updated redeemData:", redeemData);
      context.commit('SET_REDEEM_DATA', redeemData)
    },
    setCouponType(context, type) {
      let redeemData = context.state.redeemData
      redeemData.coupon_type = type
      context.commit('SET_REDEEM_DATA', redeemData)
    },
    setIsMember(context, isMemeber) {
      context.commit('SET_IS_MEMBER', isMemeber)
    },
    setIsBindStore(context, isBindStore) {
      context.commit('SET_IS_BIND_STORE', isBindStore)
    },
  },
};
